//Theme custom functions
jQuery( function( $ ) {	
	$( document ).ready( function() {

        
        if($('.page-template-template-home').length) {
            console.log("Homepage scripts");


            var sliderPropiedades = new Swiper( '.slider-propiedades .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                breakpoints: {
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },    
                  990: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },   
                }            
              });

        }

    });
});